import { PROJECT_PL_BUCKETS, type ProjectPLBucket } from '../types';
import type { ProjectPLExpenseRow, ProjectPLPaymentRow } from './projectPL';

export type ActivityFeedItem =
  | { kind: 'in'; id: string; sortMs: number; payment: ProjectPLPaymentRow }
  | { kind: 'out'; id: string; sortMs: number; expense: ProjectPLExpenseRow };

export interface ActivityFeedGroup {
  id: 'collected' | ProjectPLBucket;
  /** Signed total: payments positive, expenses negative. Excluded payments are omitted. */
  total: number;
  items: ActivityFeedItem[];
}

/**
 * Payments first, then proposal cost nodes in Project P&L bucket order.
 * Empty groups are dropped. Item order inside a group is preserved.
 */
export function groupActivityByProposalNode(items: ActivityFeedItem[]): ActivityFeedGroup[] {
  const payments = items.filter((item): item is Extract<ActivityFeedItem, { kind: 'in' }> => item.kind === 'in');
  const groups: ActivityFeedGroup[] = [];
  if (payments.length) {
    const total = payments.reduce((sum, item) => sum + (item.payment.excluded ? 0 : item.payment.amount), 0);
    groups.push({ id: 'collected', total, items: payments });
  }
  for (const bucket of PROJECT_PL_BUCKETS) {
    const expenses = items.filter(
      (item): item is Extract<ActivityFeedItem, { kind: 'out' }> => item.kind === 'out' && item.expense.bucket === bucket,
    );
    if (!expenses.length) continue;
    const total = -expenses.reduce((sum, item) => sum + item.expense.amount, 0);
    groups.push({ id: bucket, total, items: expenses });
  }
  return groups;
}
